import type { ReactNode } from 'react';
import { tw } from '@tw';
import { PAGE_WIDTH, PageColumn } from '@/components/layout/PageFrame';

/**
 * Both faces of `/invite` at the page width, edge to edge with the bar like the main page's hero:
 * what is asked on the left, the card it builds on the right (under it below `deck`).
 * Not `PageSpread`: its narrower text measure sat inset from the bar and read as a wrapper.
 */
export function InviteLayout({
  main,
  aside,
  top,
  asideOnPhone = true,
}: {
  main: ReactNode;
  aside: ReactNode;
  /** Shown above the question below `deck` only, where the aside falls under the fold. */
  top?: ReactNode;
  /** False keeps the aside to `deck` and up, when `top` already stands for it on a phone. */
  asideOnPhone?: boolean;
}) {
  return (
    <PageColumn className={PAGE_WIDTH}>
      <div className="grid gap-10 md:pt-6 deck:grid-cols-[minmax(0,1fr)_minmax(0,26rem)] deck:items-start deck:gap-16">
        <div className="flex min-w-0 max-w-xl flex-col gap-6">
          {top}
          <div className="flex flex-col">{main}</div>
        </div>
        <div
          className={tw(
            'w-full min-w-0 flex-col gap-card deck:sticky deck:top-header',
            asideOnPhone ? 'flex' : 'hidden deck:flex'
          )}
        >
          {aside}
        </div>
      </div>
    </PageColumn>
  );
}
